<div class="container-fluid">
  <div class="row justify-content-md-center my-2">
    <h3>
      Gestione Viaggi <small>Parco {{ parkName }} </small>
    </h3>
  </div>
  <div class="row mt-5">
    <div class="col-8"></div>
    <div class="col-4">
      <mat-form-field class="travels-search-input">
        <mat-label>Cerca targa</mat-label>
        <input matInput (input)="applyTravelSearchFilter($event.target.value)" placeholder="Eg. CRI001" #input />
      </mat-form-field>
    </div>
  </div>
  <div class="row justify-content-md-center">
    <div class="col">
      <table mat-table [dataSource]="travelsTableDataSource" matSort class="mat-elevation-z8">
        <ng-container matColumnDef="trv_id">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
          <td mat-cell *matCellDef="let element">{{ element.trv_id }}</td>
        </ng-container>
        <ng-container matColumnDef="trv_started_at">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>From</th>
          <td mat-cell *matCellDef="let element">
            {{ element.trv_started_at ? (element.trv_started_at | date : "dd/MM/yy HH:mm") : '-' }}
          </td>
        </ng-container>
        <ng-container matColumnDef="trv_ended_at">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>To</th>
          <td mat-cell *matCellDef="let element">
            {{ element.trv_ended_at ? (element.trv_ended_at | date : "dd/MM/yy HH:mm") : '-' }}
          </td>
        </ng-container>
        <ng-container matColumnDef="vhc_plate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Targa</th>
          <td mat-cell *matCellDef="let element">{{ element.vhc_plate ?? '-' }}</td>
        </ng-container>
        <ng-container matColumnDef="trv_start_kilometers">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>KM start</th>
          <td mat-cell *matCellDef="let element">
            {{ element.trv_start_kilometers ?? '-' }}
          </td>
        </ng-container>
        <ng-container matColumnDef="trv_end_kilometers">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>KM end</th>
          <td mat-cell *matCellDef="let element">
            {{ element.trv_end_kilometers ?? '-' }}
          </td>
        </ng-container>
        <ng-container matColumnDef="usr_surname">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>User</th>
          <td mat-cell *matCellDef="let element">
            {{ element.usr_name + " " + element.usr_surname }}
          </td>
        </ng-container>
        <ng-container matColumnDef="statusDesc">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Stato</th>
          <td mat-cell *matCellDef="let element">
            {{ element.statusDesc }}
          </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            <button mat-icon-button aria-label="Edit item" (click)="onTravelRowActionHandler(element)">
              <mat-icon>settings</mat-icon>
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="travelsDisplayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: travelsDisplayedColumns"></tr>
      </table>
      <mat-paginator [pageSizeOptions]="[50, 100, 250]" showFirstLastButtons></mat-paginator>
    </div>
  </div>
</div>
<app-admin-change-travels (travelsModified)="reloadAfterUpdateEmit()"></app-admin-change-travels>